import * as $ from "jquery";

export function activate1Question() {
    $(".ce-one-question-survey .btn-eval").on("click", function (ev) {
        let noAnswer = true;
        const $survey = $(this).parents('.ce-one-question-survey');
        $survey.find('input[type=\"radio\"]:checked').each(function () {
            $survey.find(".evaluation").addClass("d-none");
            const evaluationClass = $(this).attr('class');
            const $answer = $survey.find(".evaluation." + evaluationClass);
            $answer.removeClass("d-none");
            $answer.css("bottom", -$answer.height() - 50);
            noAnswer = false;
        });
        if (noAnswer) {
            $survey.find(".evaluation").addClass("d-none");
            const $answer = $survey.find(".evaluation.no-selection");
            $answer.removeClass("d-none");
            $answer.css("bottom", -$answer.height() - 50);
        }
    });

    $('.ce-one-question-survey .icon-close').on('click', function () {
        $(this).parent().parent().addClass("d-none");
    });

    let $answers = $(".ce-one-question-survey").find('.answer');

    $answers.each(function () {
        $(this).on("click", function () {
            $answers.attr('aria-checked', 'false');
            $(this).attr('aria-checked', 'true');
        });
    });
}